import { ChangeDetectionStrategy, Component, Input, OnInit, forwardRef } from '@angular/core';
import { IFormInput } from '../../_shared/models/form/form-input.model';
import { FormElementBase } from '../_directives/form-element-base.directive';
import { ReactiveFormsModule } from '@angular/forms';

import { InputComponent } from '../../input/input.component';

@Component({
    selector: 'sirius-form-input',
    templateUrl: './form-input.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: FormElementBase, useExisting: forwardRef(() => FormInputComponent) }],
    imports: [ReactiveFormsModule, InputComponent]
})
export class FormInputComponent extends FormElementBase implements OnInit {
    config?: IFormInput;

    @Input() type = 'text';

    ngOnInit(): void {
        if (this.config) {
            this.name = this.config.name;
            this.label = this.config.label;
            this.formFieldDependencies = this.config.dependentFormFieldComponents;
            this.validation = this.config.validation;
            this.form = this.config.form;
            this.identifier = this.config.identifier ?? '';
            this.type = this.config.type;
        }
    }
}
